module.exports = __webpack_public_path__ + "media/images/calendar-1847a5b0851e1894fa2a6ecf6035a82b.png";